<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="suppliersSelected"
    :clearable="!unclearable"
    :items="suppliersItems"
    :loading="suppliersLoading"
    :search-input.sync="suppliersSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Supplier.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
    :disabled="isDisabled"
  ></v-autocomplete>
</template>

<script>
import Suppliers from "@/api/suppliers";

export default {
  name: "SearcherSupplier",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    isDisabled: Boolean,
    type: Number,
  },

  computed: {
    suppliersItems() {
      return this.suppliers.map((supplier) => {
        const Description =
          supplier.supplier_code + " / " + supplier.supplier_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == supplier.id
            )
          : false;
        return Object.assign({}, supplier, { Description, disabled });
      });
    },
  },

  data: () => ({
    suppliers: [],
    suppliersLoading: false,
    suppliersSearch: "",
    suppliersSelected: null,
  }),

  mounted() {
    this.getSuppliersFromAPI();
  },

  methods: {
    getSuppliersFromAPI() {
      this.suppliersLoading = true;
      let options = {};
      if (this.type) {
        options = Object.assign({}, options, {
          type: this.type
        });
      }
      Suppliers.fetchAllForSelect(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers;
            }
            this.suppliersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.suppliersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.suppliersSelected = this.value;
      },
    },
    suppliersSelected: {
      handler() {
        this.$emit("input", this.suppliersSelected);
        this.$emit("change");
      },
    },
  },
};
</script>
